import ReactPixel from 'react-facebook-pixel';

type Config = {
  pixelId: string;
  enabled?: boolean;
};

export default function FacebookPixel(config: Config): any {
  let isLoaded = false;
  let ReactPixel: any;

  return {
    name: 'facebook-pixel',

    initialize: async () => {
      if (typeof window === 'undefined' || config.enabled === false) return;

      // Dynamic import
      const pixel = await import('react-facebook-pixel');
      ReactPixel = pixel.default;

      ReactPixel.init(config.pixelId, { autoConfig: true, debug: false });
      ReactPixel.pageView();
      isLoaded = true;
    },

    page: () => {
      if (isLoaded && ReactPixel) {
        ReactPixel.pageView();
      }
    },

    track: ({ payload }: any) => {
      if (isLoaded && ReactPixel) {
        ReactPixel.track(payload.event, payload.properties);
      }
    },

    loaded: () => isLoaded,
  };
}
